import ConsultaBase from "../shared/ConsultaBase";
import { fullServiceCoolingConsultaConfig } from "../config/fullServiceCoolingConsulta";

const CFullServiceCooling = () => {
  return <ConsultaBase config={fullServiceCoolingConsultaConfig} />;
};

export default CFullServiceCooling;